import React from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setLoginDetails as UserSetLoginDetails } from "../store/UserStore/action";
import { setLoginDetails as AdminSetLoginDetails } from "../store/AdminStore/action";
import { setLoginDetails as CenterOnboardSetLoginDetails } from "../store/CenterOnboardStore/action";

function axiosInterceptor(dispatch, adminState, centerOnboardState) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log({ axiosInterceptorError: error });
      const err = error?.response?.data?.status;
      if (err == 401) {
        window.location.replace("https://app.onit.services/#/admin-login");
      }

      if (
        error?.response?.data?.message?.includes("jwt expired") ||
        error?.response?.data?.message?.includes("Permission denied") ||
        error?.response?.data?.message?.includes("User not found") ||
        error?.response?.data?.message?.includes("Token is invalid")
      ) {
        if (adminState?.adminDetails?.user_name) {
          dispatch(
            AdminSetLoginDetails({
              adminDetails: {},
              isAdminLoggedIn: false,
              userTokens: {
                accessToken: "",
              },
            })
          );
          window.location.replace("https://onit.services/#/admin-login");
        } else if (centerOnboardState?.centerOnboardDetails?.name) {
          dispatch(
            CenterOnboardSetLoginDetails({
              centerOnboardDetails: {},
              isCenterOnboardLoggedIn: false,
              userTokens: {
                accessToken: "",
              },
            })
          );
          window.location.replace("https://onit.services/#/admin-login");
        } else {
          dispatch(
            UserSetLoginDetails({
              userDetails: {},
              isUserLoggedIn: false,
              userTokens: {
                accessToken: "",
              },
            })
          );
          window.location.replace("https://onit.services/#/admin-login");
        }
      }

      return Promise.reject(error);
    }
  );
}

const SetAuthToken = () => {
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.userReducer);
  const adminState = useSelector((state) => state.AdminReducer);
  const centerOnboardState = useSelector((state) => state.centerOnboardReducer);

  axiosInterceptor(dispatch, adminState, centerOnboardState);

  /* apply to every requests */
  if (adminState.isAdminLoggedIn) {
    axios.defaults.headers.common["x-access-token"] =
      adminState?.userTokens?.accessToken;
    localStorage.setItem("access_token", adminState?.userTokens?.accessToken);
  } else if (centerOnboardState?.isCenterOnboardLoggedIn) {
    axios.defaults.headers.common["x-access-token"] =
      globalState?.userTokens?.accessToken;
  } else {
    axios.defaults.headers.common["x-access-token"] =
      globalState?.userTokens?.accessToken;
  }

  return null;
};

export default SetAuthToken;
